export const declarationsFr = {
  title: 'Déclarations et allergènes',
  subtitle:
    'Propositions multilingues et versionnées issues de recettes approuvées, avec contrôle juridique.',
  help: 'Ouvrir l’aide sur les déclarations, le catalogue et les validations',
  empty: 'Aucune version ne correspond aux filtres.',
  pagination: 'Page {{page}} sur {{pages}} · {{total}} versions',
  actions: {
    catalog: 'Catalogue métier',
    generate: 'Générer une proposition',
    newTerm: 'Entrée de catalogue',
    submit: 'Soumettre au contrôle',
    review: 'Terminer le contrôle',
    approve: 'Approuver',
    publish: 'Publier',
    archive: 'Archiver',
    copy: 'Nouvelle version',
    override: 'Déroger avec motif',
    confirm: 'Confirmer',
    history: 'Versions',
  },
  filters: {
    search: 'Rechercher numéro, produit, marché ou terme',
    allStatuses: 'Tous les statuts',
    allTypes: 'Tous les types',
  },
  statuses: {
    DRAFT: 'Brouillon',
    VALIDATION_ERROR: 'Erreur de validation',
    IN_REVIEW: 'En contrôle',
    APPROVED: 'Approuvée',
    PUBLISHED: 'Publiée',
    SUPERSEDED: 'Remplacée',
    ARCHIVED: 'Archivée',
  },
  catalogStatuses: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'En contrôle',
    APPROVED: 'Approuvée',
    SUPERSEDED: 'Remplacée',
    ARCHIVED: 'Archivée',
  },
  allergenStatuses: {
    CONTAINS: 'Contient',
    MAY_CONTAIN: 'Peut contenir',
    DOES_NOT_CONTAIN: 'Ne contient pas',
    UNKNOWN: 'Inconnu',
  },
  issueSeverity: { ERROR: 'Erreur', WARNING: 'Avertissement' },
  types: {
    INGREDIENT: 'Ingrédient',
    ALLERGEN: 'Allergène',
    ADDITIVE: 'Additif',
    FUNCTION_CLASS: 'Catégorie fonctionnelle',
    ORIGIN_STATEMENT: 'Indication d’origine',
    COLLECTIVE_DESIGNATION: 'Dénomination collective',
    WARNING: 'Avertissement',
    CLAIM: 'Allégation',
    PRODUCT_DESIGNATION: 'Dénomination légale/produit',
    QUID_RULE: 'Règle QUID',
  },
  columns: {
    number: 'Numéro',
    product: 'Produit',
    market: 'Marché',
    version: 'Version',
    status: 'Statut',
    issues: 'Erreurs / avertissements',
    updated: 'Modifiée',
    key: 'Clé',
    type: 'Type',
    name: 'Dénomination',
    validity: 'Validité',
    path: 'Source / chemin',
    weight: 'Poids pertinent',
    percentage: 'Part',
    flags: 'Indicateurs',
    field: 'Champ',
    recipe: 'Recette',
  },
  fields: {
    key: 'Clé stable',
    type: 'Type métier',
    code: 'Code / numéro E',
    metadata: 'Métadonnées configurables (JSON)',
    validFrom: 'Valide à partir du',
    validTo: 'Valide jusqu’au',
    changeReason: 'Motif de modification',
    name: 'Dénomination',
    synonyms: 'Synonymes séparés par des virgules',
    description: 'Description',
    reason: 'Note de contrôle ou décision',
    recipe: 'Version de recette approuvée',
    number: 'Numéro de déclaration (facultatif)',
    market: 'Clé marché/règles',
    ingredients: 'Liste des ingrédients',
    allergens: 'Mention des allergènes',
    additives: 'Additifs',
    warnings: 'Avertissements et origine',
    productDesignation: 'Dénomination légale/produit',
    ingredientText: 'Liste des ingrédients',
    allergenText: 'Mention des allergènes',
    additiveText: 'Texte des additifs',
    warningText: 'Avertissements et origine',
    overrideReason: 'Motif de la dérogation manuelle',
    warningAcknowledgement: 'Acceptation motivée de tous les avertissements restants',
  },
  catalog: {
    title: 'Catalogue de déclaration configurable',
    subtitle:
      'Ingrédients, allergènes, additifs, catégories, règles et termes linguistiques versionnés.',
    empty: 'Aucune version de catalogue trouvée.',
    createTitle: 'Créer une entrée',
    editTitle: 'Modifier la version v{{version}}',
    editorHelp:
      'Les nombres des métadonnées sont des chaînes décimales. Toutes les langues doivent être complètes avant contrôle.',
    historyTitle: 'Historique des versions : {{key}}',
    historyDescription:
      'Les termes approuvés sont immuables ; toute modification crée une version.',
  },
  generate: {
    title: 'Générer une proposition de déclaration',
    description:
      'Le moteur résout de façon reproductible la nomenclature, les sous-recettes et les ingrédients composés approuvés.',
    legalWarning:
      'Il ne s’agit pas d’une validation juridique automatique. Un contrôle expert indépendant et une publication explicite sont requis.',
  },
  detail: {
    subtitle: 'Version {{version}} · Marché {{market}} · Source {{recipe}} v{{recipeVersion}}',
  },
  legal: {
    title: 'Contrôle expert et juridique requis',
    description:
      'La proposition, le QUID, les allégations, avertissements et traductions doivent être contrôlés par des personnes qualifiées avant tout usage juridiquement contraignant.',
  },
  summary: {
    status: 'Statut du workflow',
    ingredients: 'Positions ingrédients',
    allergens: 'Constats allergènes',
    errors: 'Erreurs de validation',
    warnings: 'Avertissements',
  },
  tabs: {
    preview: 'Aperçu linguistique',
    comparison: 'Comparaison des langues',
    sources: 'Sources et instantané',
    validation: 'Validation',
    history: 'Historique',
  },
  sections: {
    ingredients: 'Ingrédients triés par poids',
    allergens: 'Allergènes dérivés',
    additives: 'Additifs et catégories fonctionnelles',
    sourceSnapshot: 'Preuve de source immuable',
    validation: 'Validation et qualité des données',
    history: 'Révisions de déclaration',
  },
  preview: {
    ingredientText: 'Version effective à approuver pour cette langue.',
    sorting: 'L’ordre et les pourcentages sont calculés exactement à partir du poids déclaratif.',
    unknownWarning: '« Inconnu » n’est jamais assimilé à « ne contient pas ».',
  },
  comparison: {
    title: 'Comparer toutes les langues prises en charge',
    description: 'Les valeurs en jaune sont des écarts motivés par rapport au calcul automatique.',
    automatic: 'Afficher le texte calculé automatiquement',
  },
  sources: {
    description: 'Les versions approuvées concrètes et le hachage assurent la reproductibilité.',
    approvedAt: 'Recette approuvée le',
    profiles: 'Versions des profils matière',
    catalogVersions: 'Versions du catalogue',
    materialSources: 'Sources matière',
  },
  validation: {
    description:
      'Les erreurs bloquent le contrôle. Les avertissements doivent être évalués et acceptés avant approbation.',
  },
  history: {
    description: 'Les versions publiées restent inchangées sous forme d’instantanés complets.',
  },
  states: {
    noAllergens: 'Aucun constat allergène dans les sources approuvées.',
    noAdditives: 'Aucun additif dans les sources approuvées.',
    noIssues: 'Aucune erreur ni alerte de qualité des données.',
    notFound: 'Version de déclaration introuvable.',
  },
  override: {
    title: 'Documenter les dérogations manuelles',
    description:
      'Les textes automatiques restent dans l’instantané. Chaque modification est tracée avec son motif technique.',
  },
  publish: {
    confirmation:
      'La confirmation publie exactement cet instantané approuvé et immuable. Elle ne remplace pas un conseil juridique externe.',
  },
  actionDialog: {
    APPROVE: {
      title: 'Approuver la déclaration',
      description:
        'L’approbation indépendante fige la version. Les avertissements restants exigent une acceptation traçable.',
    },
    COPY: {
      title: 'Créer une version du catalogue',
      description: 'Le contenu est copié dans un nouveau brouillon modifiable.',
    },
    ARCHIVE: {
      title: 'Archiver la version',
      description: 'La version reste auditable mais n’est plus active pour de nouveaux usages.',
    },
    REVIEW: {
      title: 'Terminer le contrôle expert',
      description:
        'Documenter le contrôle indépendant des sources, calculs, langues et avertissements.',
    },
    PUBLISH: {
      title: 'Publier explicitement la déclaration',
      description: 'La publication est une étape juridique distincte après approbation.',
    },
  },
  messages: {
    generated: 'Proposition générée de façon reproductible.',
    saved: 'Version du catalogue enregistrée.',
    overrideSaved: 'Dérogations manuelles enregistrées.',
    submitted: 'Déclaration soumise à un contrôle indépendant.',
    workflow: 'Workflow mis à jour avec piste d’audit.',
  },
} as const;
